import { PrivacyPolicy } from 'components/PrivacyPolicy';

const ScreenPrivacyPolicy = () => <PrivacyPolicy />;

export default ScreenPrivacyPolicy;
